module.exports = __webpack_public_path__ + "graphics/07.ckh.89425cb766763ee1ecebad8f3bae32d3.png";